<template>
  <v-footer app padless inset>
    <v-col
        cols="12"
    >
      © {{ new Date().getFullYear() }} — Powered by <strong>Marcelo Rodovalho</strong>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  name: 'Footer',
}
</script>